import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  padding: 18px 16px 8px;
  margin-bottom: -28px;
  z-index: 2;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 100%
  );

  @media (min-width: 768px) {
    padding: 16px 20px;
  }

  @media (min-width: 961px) {
    width: 100%;
    top: ${props => props.withProgressBar ? 'auto' : '-48px'};
  }

  ${(props) =>
    props.backgroundIsMedia && {
      '@media (min-width: 961px)': {
        position: 'absolute',
        left: '-100%',
        right: '100%',
        top: `${props.withProgressBar ? 'auto' : 0}`,
      },
    }}

  @media (min-width: 1024px) {
    padding: 16px 24px;
  }
`;
